import React from 'react';
import {
  dataGridDateSorter,
  dataGridNumberSorter,
  dataGridTextSorter,
} from '../../../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { IconButton } from '../../../../../../common/controls/Controls.jsx';
import {
  CreditCardOutlined,
  TeamOutlined,
  FileSearchOutlined,
  EditOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
} from '@ant-design/icons';
import { routes } from '../../../../../../../utils/helpers/ApiClient.jsx';
import { QuestionModal } from '../../../../../../common/index.jsx';
import { FIJ_INTEREST_STATUS } from '../../../../../../../utils/constants/enums.js';

export const CurrentJobsConfig = ({
  t,
  navigate,
  permissions,
  handlers,
  filterHooks,
  fromPublic,
}) => {
  return {
    columns: [
      {
        title: t('Názov'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        ...filterHooks.nameTextFilterProps,
      },
      {
        title: t('Lektor'),
        dataIndex: 'supervisor_full_name',
        ellipsis: true,
        sorter: dataGridTextSorter('supervisor_full_name'),
        ...filterHooks.supervisorTextFilterProps,
      },
      {
        title: t('Začiatok'),
        dataIndex: 'date_from',
        width: 120,
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        sorter: dataGridDateSorter('date_from'),
        ...filterHooks.fromDateRangeFilterProps,
      },
      {
        title: t('Koniec'),
        dataIndex: 'date_to',
        width: 120,
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        sorter: dataGridDateSorter('date_to'),
        ...filterHooks.toDateRangeFilterProps,
      },
      {
        title: t('Kapacita'),
        dataIndex: 'student_capacity',
        width: 110,
        sorter: dataGridNumberSorter('student_capacity'),
      },
      {
        title: t('Praktikanti'),
        dataIndex: 'accepted',
        width: 120,
        sorter: dataGridNumberSorter('accepted'),
      },
    ],

    customActions: (record) => {
      const isInterested = !!record.my_interest_id;
      const isApplicationPending =
        record.my_interest_status === FIJ_INTEREST_STATUS.WAITING;

      const hasEnded = record.date_to
        ? new Date(record.date_to) < new Date()
        : false;

      const studentCapacity = Number(record.student_capacity);
      const accepted = Number(record.accepted);
      const isCapacityFull =
        Number.isFinite(studentCapacity) &&
        studentCapacity > 0 &&
        Number.isFinite(accepted) &&
        accepted >= studentCapacity;

      return (
        <div style={{ display: 'flex' }}>
          {permissions.isFijAdmin && (
            <IconButton
              icon={<EditOutlined />}
              tooltip={t('Upraviť')}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`${routes.cmsFijJobEdit}/${record.id}`);
              }}
            />
          )}

          <IconButton
            icon={<FileSearchOutlined />}
            tooltip={t('Zobraziť detail')}
            onClick={(e) => {
              e.stopPropagation();
              navigate(
                `${fromPublic ? routes.fijJobDetail : routes.cmsFijJobDetail}/${record.id}`,
              );
            }}
          />

          {permissions.isFijAdmin && (
            <>
              <IconButton
                icon={<TeamOutlined />}
                tooltip={t('Zobraziť záujemcov / praktikantov')}
                disabled={
                  (record.interested === 0 || record.interested === '0') &&
                  (record.accepted === 0 || record.accepted === '0')
                }
                disabledTooltip={t('Nie sú záujemcovia / praktikanti')}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`${routes.cmsFijInterestedStudents}/${record.id}`);
                }}
              />
              <IconButton
                icon={<CreditCardOutlined />}
                tooltip={t('Archivovať')}
                onClick={(e) => {
                  e.stopPropagation();
                  handlers.openArchiveModal(record);
                }}
              />
            </>
          )}

          {permissions.isFijIntern && isInterested && isApplicationPending && (
            <IconButton
              icon={<UserDeleteOutlined />}
              tooltip={t('Odhlásiť sa z FRI praxe')}
              onClick={(e) => {
                e.stopPropagation();
                handlers.openDeleteInterestModal(record);
              }}
            />
          )}

          {permissions.isFijIntern &&
            !isInterested &&
            !isCapacityFull &&
            !hasEnded && (
              <IconButton
                icon={<UserAddOutlined />}
                tooltip={t('Prihlásiť sa na FRI prax')}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(
                    `${routes.cmsFijInterestsCreate}/${record.id}/fromList`,
                  );
                }}
              />
            )}
        </div>
      );
    },

    modals: ({ modalState, closeModal, onConfirm }) => (
      <>
        <QuestionModal
          chosenPositive={onConfirm}
          question={t(
            'Naozaj chcete archivovať vybranú FRI prax? Prax sa nebude ponúkať študentom a bude zobrazená len v archíve.',
          )}
          visible={modalState.type === 'archive'}
          yes={t('Áno')}
          toggle={closeModal}
          headerTitle={t('Archivovať')}
        />
        <QuestionModal
          chosenPositive={onConfirm}
          question={t('Naozaj sa chcete odhlásiť z FRI praxe?')}
          visible={modalState.type === 'deleteInterest'}
          yes={t('Áno')}
          toggle={closeModal}
          headerTitle={t('Odhlásiť sa z FRI praxe')}
        />
      </>
    ),
  };
};
